import { InjectionToken } from '@angular/core';
import { BerichtsGroup, BerichtID, Alert } from './berichte.types.ts.js';

export const ALERTS_IDS = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14] as const;

export function isBerichtID(alertID: Alert['AlertID']): alertID is BerichtID {
  if (ALERTS_IDS.includes(alertID as BerichtID)) return true;
}

export const BERICHTE_CONFIG = new InjectionToken('Statische Konfigurationen für Berichte', {
  factory: () => {
    const BERICHTS_ARTEN = [
      {
        name: 'Mängel',
        arten: [
          {
            id: 2,
            titel: 'Fehlerklasse 1 nach Inspektion',
            description:
              'Erstellt eine Liste mit allen Mängel der Fehlerklasse 1, die bei der letzten Inspektion aufgenommen wurden.',
          },
        ],
      },
      {
        name: 'Termine',
        arten: [
          {
            id: 3,
            titel: 'Wartungstermin überschritten',
            description: 'Erstellt eine Liste mit allen Objekten, bei denen der Wartungstermin überschritten wurde.',
          },
          {
            id: 4,
            titel: 'Prüftermin überschritten',
            description: 'Erstellt eine Liste mit allen Objekte, bei denen der Prüftermin überschritten wurde.',
          },
          {
            id: 5,
            titel: 'Bestätigung durch den ALV erforderlich',
            description:
              'Erstellt eine Liste mit allen Objekte, welche vom Anlagenverantwortlichen zu bestätigen sind.',
          },
          {
            id: 6,
            titel: 'Bestätigung durch den EBL erforderlich',
            description:
              'Erstellt eine Liste mit allen Objekten, die vom Eisenbahnbetriebsleiter zu bestätigen sind.',
          },
        ],
      },
      {
        name: 'Statistik',
        arten: [
          {
            id: 7,
            titel: 'Fehleranzahl / Objekttyp',
            description: 'Diese Funktion bietet eine statistische Auswertung von Fehleranzahl je Objekttyp.',
          },
          {
            id: 8,
            titel: 'Fehlerklassen / Objekttyp',
            description: 'Diese Funktion bietet eine statistische Auswertung von Fehlerklassen je Objekttyp.',
          },
          {
            id: 9,
            titel: 'Fehlerhäufigkeit / Objekttyp',
            description: 'Diese Funktion bietet eine statistische Auswertung von Fehlerhäufigkeit je Objekttyp.',
          },
          {
            id: 10,
            titel: 'minimale Dauer Instandsetzung pro Fehlerklasse',
            description: 'Die kürzeste Dauer von der Feststellung eines Mangel bis zur dokumentierten Behebung.',
          },
          {
            id: 11,
            titel: 'maximale Dauer Instandsetzung pro Fehlerklasse',
            description: 'Die längest Dauer von der Feststellung eines Mangel bis zur dokumentierten Behebung.',
          },
          {
            id: 12,
            titel: 'durchschnittliche Dauer Instandsetzung pro Fehlerklasse',
            description:
              'Die druchschnittliche Dauer von der Feststellung eines Mangel bis zur dokumentierten Behebung.',
          },
          {
            id: 13,
            titel: 'Wartungstermine',
            description: 'Erstellt eine Liste mit allen Objekten, bei denen der Wartungstermin bevorsteht.',
          },
          {
            id: 14,
            titel: 'Prüftermine',
            description: 'Erstellt eine Liste mit allen Objekten, bei denen der Prüftermin bevorsteht.',
          },
        ],
      },
    ] as const satisfies BerichtsGroup[];

    const REPEAT_OPTIONS = {
      '0': 'täglich',
      '1': 'wöchentlich',
      '2': 'monatlich',
    } as const;

    return { BERICHTS_ARTEN, REPEAT_OPTIONS };
  },
});
